export default __webpack_public_path__ + "static/media/header_logo.df8e1476.jpeg";